import _ from 'lodash'
import { mapActions, mapState } from 'vuex'
import SlideApi from '@/api/slide'
import { setObjectToIndexedDB, Stores, removeObjectFromIndexedDB } from '@/utils/indexedDB/indexed.db'
import Socket from '@/socket.js'

export default {
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'updateSlideByIdAction']),
    // Why need to debounce: canvasBlocks are updated on every mouse drag, so if we don't debounce, it will call API too much
    callUpdateSlideApi: _.debounce(async function debounceUpdateSlide(payload, slideId) {
      if (!slideId) return
      await SlideApi.updateSlideById(slideId, {
        ...payload,
        uniqueAccessCode: this.presentation.uniqueAccessCode,
        socketId: Socket.getSocketId(),
      })
    }, 1000, { leading: true, trailing: true }),

    // Caching canvasBlocks to IndexedDB is Deprecated at the moment
    updateCanvasBlocksToIndexedDB(payload, slideId) {
      setObjectToIndexedDB(slideId, Stores.contentSlideCanvasBlocksStore, {
        canvasBlocks: payload.newCanvasBlocks,
      }, () => { // on error
        // if failed to set to IndexedDB -> remove the object in IndexedDB, to ensure that future access will get the latest data on DB
        removeObjectFromIndexedDB(slideId, Stores.contentSlideCanvasBlocksStore, () => {}, () => {})
        // Update on DB via calling slide/update API
        this.callUpdateSlideApi(payload, slideId)
      }, () => { // on success
        // Update on DB via calling slide/update API
        this.callUpdateSlideApi(payload, slideId)
      })
    },

    updateCanvasBlocks(newCanvasBlocks, slideId) {
      const payload = {
        id: slideId,
        type: 'freestyle',
        canvasBlocks: newCanvasBlocks,
      }
      // Update on local state
      this.updateSlideByIdAction(payload)
      // Update on DB via calling slide/update API
      this.callUpdateSlideApi(payload, slideId)
    },
  },
}
